import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BaseLabel",
  props: {
    inputId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    clientLogin: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup() {}
});